import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { reorderCourseLectureItems as reorderCourseLectureItemsApi } from "@/services/dashboard/apiLecture";

export function useReorderCourseLectureItems() {
    const queryClient = useQueryClient();

    const {
        mutate: reorderCourseLectureItems,
        isPending: isReordering,
        error,
    } = useMutation({
        mutationFn: reorderCourseLectureItemsApi,
        onSuccess: () => {
            toast.success("تم تغيير الترتيب");

            queryClient.invalidateQueries({
                queryKey: ["lectureItemsDashboard"],
            });
        },

        onError: (error) => {
            toast.error(error.response.data.message);
        },
    });

    return { reorderCourseLectureItems, isReordering, error };
}
